export function FullPageLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-3 text-fg-muted" role="status">
      <span className="size-8 animate-spin rounded-full border-2 border-border border-t-accent" aria-hidden />
      <span className="text-sm">{label}</span>
    </div>
  );
}
